<script setup lang="ts">
const props = defineProps<{ label: string; data?: string | number | null }>()
const _data = computed(() => (props.data ? props.data : 'N/A'))
</script>

<template>
  <div class="flex flex-col items-start gap-1">
    <div class="text-xs rounded-full bg-primary text-current px-2 py-1 leading-none">
      {{ label }}
    </div>
    <div class="font-bold pl-2">
      <template v-if="$slots.default">
        <slot />
      </template>

      <template v-else>{{ _data }}</template>
    </div>
  </div>
</template>
